export default __webpack_public_path__ + "static/media/eot1.19bbb006.png";